export const educationData = [
    {
        id: 1,
        institution: 'Jimma University',
        course: "Bachelor's Degree in Software Engineering",
        startYear: '2019',
        endYear: '2024',
        detail: 'CGPA 3.50 / 4.0',
    },
]

export const certificationsData = [
    'AI Fundamentals, Udacity',
    'Data Analysis Fundamentals, Udacity',
    'Programming Fundamentals, Udacity',
    'Programming with JavaScript, Coursera',
    'Introduction to Front-End Development, Coursera',
    'JavaScript Algorithms and Data Structures, freeCodeCamp',
    'Web Application Development Training, Jimma University',
]
